import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Chip, IconButton, Tooltip, Typography } from '@mui/material';
import { FormMode } from 'common/constants/enums';
import { useFormContext, useWatch } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import type { IPageFormV2 } from '../page-builder-v2.types';

interface PageBuilderV2HeaderProps {
  formMode: FormMode;
}

const formatDate = (iso?: string) => {
  if (!iso) return null;
  return new Date(iso).toLocaleString(undefined, {
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

export const PageBuilderV2Header = ({ formMode }: PageBuilderV2HeaderProps) => {
  const navigate = useNavigate();
  const { control } = useFormContext<IPageFormV2>();
  const title = useWatch({ control, name: 'title' });
  const createdAt = useWatch({ control, name: 'created_at' as any });
  const updatedAt = useWatch({ control, name: 'updated_at' as any });

  const isCreate = formMode === FormMode.CREATE;

  return (
    <Box sx={{ alignItems: 'flex-start', display: 'flex', gap: 1.5, mb: 3 }}>
      <Tooltip title="Back to pages">
        <IconButton onClick={() => navigate('/pages')} size="small" sx={{ mt: 0.25 }}>
          <ArrowBackIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Box sx={{ alignItems: 'center', display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          <Typography fontWeight={700} noWrap variant="h6">
            {isCreate ? 'Create Page' : (title || 'Edit Page')}
          </Typography>
          <Chip
            color={isCreate ? 'success' : 'primary'}
            label={isCreate ? 'New' : 'Editing'}
            size="small"
            variant="outlined"
          />
        </Box>

        {!isCreate && (createdAt || updatedAt) && (
          <Typography color="text.disabled" sx={{ mt: 0.5 }} variant="caption">
            {updatedAt
              ? `Last updated: ${formatDate(updatedAt)}`
              : `Created: ${formatDate(createdAt)}`}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
